import { faLaptopMobile, faMug } from "@fortawesome/pro-light-svg-icons"
import { ButtonConfigType } from "./StandardOrderTypeFilter"

// Order type for filtering purposes
export enum OrderFilterType {
    ALL = "ALL",
    POS = "POS",
    MEETING_SERVICE = "MEETING_SERVICE",
}

// Configuration for order filtering buttons
export const orderFilterButtonConfig: ButtonConfigType<OrderFilterType>[] = [
    {
        value: OrderFilterType.ALL,
        icon: null,
        className: "buttonGreen",
    },
    {
        value: OrderFilterType.POS,
        icon: faLaptopMobile,
        className: "buttonBlue",
    },
    {
        value: OrderFilterType.MEETING_SERVICE,
        icon: faMug,
        className: "buttonPurple",
    },
]
